import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import { WebEngage, GA, PGAD } from "../../../integrations";
import BreadCrumb from "../story/story-templates/shared/breadcrumbs";
import { ZodiacIcon } from "../../atoms/icon";
import Navbar from "../../atoms/secondary-menu";
import { StoryCard } from "../story/story-templates/shared/story-card";
import { DfpAd } from "../../atoms/dfp-ad";
import styles from "./styles.m.css";
import { PAGE_TYPE } from "../../../../isomorphic/constants";
import Media from "react-media";
import { PGAdwithAd, VikatanSticky } from "../../rows/ad-free";

const getZodiacHref = (slug, peyarchiType) => {
  const storySlug = slug.split("/").pop();
  return `/horoscope/${peyarchiType}/${storySlug}`;
};

const getCurrentZodiac = (collection, story, zodiacs) => {
  let currentZodiac = {};
  let index = collection.items.findIndex(({ id }) => story.id === id);
  if (index < 0) {
    return "";
  }
  currentZodiac.type = zodiacs[index].type;
  currentZodiac.name = zodiacs[index]["display_name"];
  return currentZodiac;
};

const SideBar = ({ zodiacs, className = "", collection, currentZodiac, peyarchiType }) => {
  const stories = get(collection, ["items"], []).map(story => story.story);
  const signs = stories.map(({ slug }, index) => {
    const zodiac = zodiacs[index] || {};
    return (
      <Link
        aria-label="Zodiac sign"
        href={getZodiacHref(slug, peyarchiType)}
        key={zodiac.type}
        className={`${styles["sidebar__zodiac"]}`}
      >
        <ZodiacIcon
          type={zodiac.type}
          className={styles["sidebar__zodiac-icon"]}
          hoverDefault={currentZodiac.type === zodiac.type}
        />
        <h3 className={styles["sidebar__zodiac-name"]}>{zodiac.display_name}</h3>
      </Link>
    );
  });
  return <div className={`${className} ${styles["sidebar"]}`}>{signs}</div>;
};

SideBar.propTypes = {
  zodiacs: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      display_name: PropTypes.string,
      dates: PropTypes.string
    })
  ),
  className: PropTypes.string,
  currentZodiac: PropTypes.shape({
    type: PropTypes.string,
    name: PropTypes.string
  }),
  collection: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        story: PropTypes.shape({
          slug: PropTypes.string
        })
      })
    )
  }),
  peyarchiType: PropTypes.string
};

export const GurupeyarchiStoryPage = ({ data, config }) => {
  const story = get(data, ["story"], null);
  if (!story) {
    return null;
  }

  const currentZodiac = getCurrentZodiac(data.collection, data.story, data.zodiacs);
  const name = get(data, ["collection", "name"], "");
  const summary = get(data, ["collection", "summary"], "");
  const subMenu = get(data, ["menuData"], {});
  const peyarchiType = get(data, ["peyarchiType"], "gurupeyarchi");

  React.useEffect(() => {
    WebEngage.registerPageView();
    GA.registerPageView(PAGE_TYPE.GURUPEYARCHI_STORY_PAGE, { story, collection: data["collection"] });
    PGAD.loadScript();
  }, []);

  return (
    <div className={`${styles["page"]}`}>
      <div />
      <div>
        {subMenu ? (
          <Navbar
            menuGroup={subMenu}
            slug={"spiritual"}
            className={styles["submenu"]}
            communityColor={subMenu.bgColor}
          />
        ) : null}
        <DfpAd className={`hidden-desktop`} adtype="Mobile_leaderboard" placement="gurupeyarchi-story" />
        <div className={styles["base"]}>
          <div className={`container`}>
            <BreadCrumb config={config} collection={data.collection} story={story} />
            <div className={styles["grid"]}>
              <SideBar
                className={styles.sidebar}
                zodiacs={data.zodiacs}
                collection={data.collection}
                currentZodiac={currentZodiac}
                peyarchiType={peyarchiType}
              />
              <div className={styles.content}>
                <div className={styles["header"]}>
                  <ZodiacIcon type={currentZodiac.type} className={styles["header__zodiac-icon"]} hoverDefault={true} />
                  <div className={styles.header__content}>
                    <h1 className={styles.header__headline}>{`${currentZodiac["name"]} - ${name}`}</h1>
                    <div className={styles.header__summary} dangerouslySetInnerHTML={{ __html: summary }} />
                  </div>
                </div>
                <PGAdwithAd
                  adId={`Vikatan2023_Mobile_SP_MID1_336x280`}
                  adSize={[[336, 280], [300, 250], [320, 100], [320, 50]]}
                  minHeight={280}
                  adDivId="div-ad-desk-3849069-1690280872-1"
                  class="ad_300_250 hidden-desktop"
                />
                <div className={styles.story}>
                  {story.cards.map((card, index) => (
                    <React.Fragment key={card.id}>
                      <StoryCard card={card} story={story} />
                      {index % 2 === 1 && (
                        <PGAdwithAd
                          adId={`Vikatan2023_Mobile_SP_MID1_336x280`}
                          adSize={[[336, 280], [300, 250], [320, 100], [320, 50]]}
                          minHeight={280}
                          adDivId="div-ad-desk-3849069-1690280875-1"
                          class="ad_300_250 hidden-desktop"
                        />
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
              <aside>
                <Media query="(min-width:768px)">
                  <div>
                    <PGAdwithAd
                      adId={`Vikatan_article_mrec_top`}
                      adSize={[[320, 250]]}
                      minHeight={250}
                      adDivId="div-ad-desk-3849069-84514-13"
                      class="ad_300_250"
                    />
                    <div className={styles["series-wrapper"]}>
                      <Link className={styles["series-wrapper-link"]} href="/series?pfrom=homepage-mainrow-series">
                        <img
                          src="https://media.vikatan.com/vikatan/2026-04-13/3an4ocid/VikatanThodarkalBanneropt2.png?format=webp&w=300&dpr=1.0"
                          alt="series"
                          width="350px"
                          height="425px"
                        />
                      </Link>
                    </div>
                  </div>
                </Media>

                <Media query="(min-width:768px)">
                  <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
                    <PGAdwithAd
                      adId={`Vikatan2023_Desktop_AP_RHS_300x600`}
                      adSize={[[300, 600]]}
                      minHeight={600}
                      adDivId="div-ad-desk-3849069-877415-123"
                      class="ad-300x600"
                    />
                  </div>
                </Media>
                <Media query="(max-width:767px)">
                  <PGAdwithAd
                    adId={`Vikatan2023_Desktop_AP_RightMID_336x280`}
                    adSize={[[336, 280], [300, 250]]}
                    minHeight={250}
                    adDivId="div-ad-desk-3849069-877415-12"
                    class="ad_300_250"
                  />
                </Media>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <VikatanSticky placement="story" />
      <div />
    </div>
  );
};

GurupeyarchiStoryPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.shape({
      name: PropTypes.string,
      summary: PropTypes.string,
      items: SideBar.propTypes.collection.items
    }),
    menubarData: PropTypes.shape(Navbar.propTypes),
    zodiacs: SideBar.propTypes.zodiacs,
    peyarchiType: PropTypes.string
  }),
  config: PropTypes.shape({
    contentInsightsId: PropTypes.string
  })
};

export default GurupeyarchiStoryPage;
